var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { FormatOptions, KtsDateTimeService, PickerOptions } from './datetime.service';
var KtsDateTimeComponent = /** @class */ (function (_super) {
    __extends(KtsDateTimeComponent, _super);
    function KtsDateTimeComponent(service, baseService, datetimeService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.datetimeService = datetimeService;
        _this.defOptions = new PickerOptions();
        _this.formatOptions = new FormatOptions();
        return _this;
    }
    KtsDateTimeComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.msg) {
            this.defOptions = this.datetimeService.getDefOptions(this.col, this.msg);
            this.formatOptions = this.defOptions.formats;
        }
        if (changes.col) {
            this.dateCol = this.getCol(JSOG.parse(JSON.stringify(this.col)), 'date');
            this.timeCol = this.getCol(JSOG.parse(JSON.stringify(this.col)), 'time');
        }
        if (changes.val) {
            if (this.val) {
                var date = flatpickr.parseDate(this.val, this.formatOptions.format);
                this.dateVal = flatpickr.formatDate(date, this.formatOptions.formatDate);
                this.timeVal = flatpickr.formatDate(date, this.formatOptions.formatTime);
            }
            else {
                this.dateVal = '';
                this.timeVal = '';
            }
        }
    };
    KtsDateTimeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsDateTimeComponent.prototype.getCol = function (col, type) {
        col.key = '$' + type + '.' + col.key;
        col.controlType = type;
        if (col.params && col.params.range) {
            col.params.range.from = '$' + type + '.' + col.params.range.from;
            col.params.range.to = '$' + type + '.' + col.params.range.to;
        }
        if (type === 'date') {
            $.extend(true, col, { params: { formClass: { width: '150' } } });
        }
        else {
            col.required = false;
        }
        return col;
    };
    KtsDateTimeComponent.prototype.onChangeVal = function (e) {
        if (e.key.match(/\$date\./)) {
            if (e.val) {
                var datetime = void 0;
                if (this.val) {
                    datetime = flatpickr.parseDate(this.val, this.formatOptions.format);
                }
                else {
                    datetime = new Date();
                    datetime.setHours(this.getDefaultHour(), this.getDefaultMinute(), 0, 0);
                }
                var date = flatpickr.parseDate(e.val, this.formatOptions.formatDate);
                datetime.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                _super.prototype.onChange.call(this, flatpickr.formatDate(datetime, this.formatOptions.format));
            }
            else {
                _super.prototype.onChange.call(this, null);
            }
        }
        else if (e.key.match(/\$time\./)) {
            var datetime = flatpickr.parseDate(this.val, this.formatOptions.format);
            if (e.val) {
                var time = flatpickr.parseDate(e.val, this.formatOptions.formatTime);
                datetime.setHours(time.getHours(), time.getMinutes(), 0, 0);
            }
            else {
                datetime.setHours(this.getDefaultHour(), this.getDefaultMinute(), 0, 0);
            }
            _super.prototype.onChange.call(this, flatpickr.formatDate(datetime, this.formatOptions.format));
        }
    };
    KtsDateTimeComponent.prototype.getDefaultHour = function () {
        if (this.defOptions.defaultHour) {
            return this.defOptions.defaultHour;
        }
        return 0;
    };
    KtsDateTimeComponent.prototype.getDefaultMinute = function () {
        if (this.defOptions.defaultMinute) {
            return this.defOptions.defaultMinute;
        }
        return 0;
    };
    KtsDateTimeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-datetime',
                    template: "\n        <div *ngIf=\"dateCol\" class=\"form_li form_li-w150\">\n            <kts-column-date [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\"\n                             [col]=\"dateCol\" [val]=\"dateVal\" [datetimeFlg]=\"true\"\n                             [msg]=\"msg\" [err]=\"err\" (changeVal)=\"onChangeVal($event)\"></kts-column-date>\n        </div><div *ngIf=\"timeCol\" class=\"form_li form_li-w100\">\n            <kts-column-time [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\"\n                             [col]=\"timeCol\" [val]=\"timeVal\" [datetimeFlg]=\"true\" [datetimeVal]=\"val\"\n                             [msg]=\"msg\" [err]=\"err\" (changeVal)=\"onChangeVal($event)\"></kts-column-time>\n        </div>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsDateTimeComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsDateTimeService }
    ]; };
    return KtsDateTimeComponent;
}(ColumnBaseComponent));
export { KtsDateTimeComponent };
//# sourceMappingURL=datetime.component.js.map